/*
===============================================

 GtagManager

===============================================
*/
export default class GtagManager{

	/**
	 * gtag送信する
	 * @param {string}  page_path
	 * @param {string}  page_title
	 */
	static send(page_path,page_title){
		if(typeof window.gtag === 'function'){
			window.gtag('config', 'UA-194856643-1', {
				'page_title' : page_title,
				'page_path': page_path
			});
		}
	}

	constructor(){
	}
}

